import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';
import BigPlayButton from 'components/BigPlayButton';
import { TranslateMapContext } from 'contexts/TranslateMapContext';

import {
  Description,
  EndedTopPartWrap,
  EndedWrap,
} from './styles/PlayerSkinStyled';

const PlayerSkinEnded = ({ onRetry, contentType, translate, playerWidth }) => (
  <EndedWrap onClick={onRetry}>
    <EndedTopPartWrap>
      {contentType === 'trailer' && (
        <Description>
          <TranslateMapContext.Consumer>
            {(translateKeys) => (
              <Text color="white" size="xxs">
                {translate(translateKeys.trailer)}
              </Text>
            )}
          </TranslateMapContext.Consumer>
        </Description>
      )}
    </EndedTopPartWrap>
    <BigPlayButton playerWidth={playerWidth} />
  </EndedWrap>
);

PlayerSkinEnded.propTypes = {
  translate: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  contentType: PropTypes.string.isRequired,
  playerWidth: PropTypes.number.isRequired,
};

export default PlayerSkinEnded;
